import { MdsItemListAsyncCollectionRow } from "@/design-system/components/item-list/rows/MdsItemListAsyncCollectionRow";
import { MdsItemListAsyncNoteRow } from "@/design-system/components/item-list/rows/MdsItemListAsyncNoteRow";
import { MdsItemListAsyncTemplateRow } from "@/design-system/components/item-list/rows/MdsItemListAsyncTemplateRow";
import { MdsItemListAsyncSessionRow } from "@/design-system/components/item-list/rows/MdsItemListAsyncSessionRow";
import { MdsItemListCarouselRow } from "@/design-system/components/item-list/rows/MdsItemListCarouselRow";
import { MdsItemListItemRow } from "@/design-system/components/item-list/rows/MdsItemListItemRow";
import { MdsItemListOtherRow } from "@/design-system/components/item-list/rows/MdsItemListOtherRow";
import { MdsItemListSectionHeaderRow } from "@/design-system/components/item-list/rows/MdsItemListSectionHeaderRow";
import { MdsItemListSkeletonRow } from "@/design-system/components/item-list/rows/MdsItemListSkeletonRow";
import { MdsItemListRowData, MdsItemListRowType } from "@/design-system/components/item-list/types";
import { FC } from "react";

interface MdsItemListRowRendererProps {
  index: number;
  data: MdsItemListRowData;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsItemListRowRenderer: FC<MdsItemListRowRendererProps> = ({ data }) => {
  switch (data.type) {
    case MdsItemListRowType.Skeleton:
      return <MdsItemListSkeletonRow data={data} />;
    case MdsItemListRowType.Carousel:
      return <MdsItemListCarouselRow data={data} />;
    case MdsItemListRowType.Item:
      return <MdsItemListItemRow data={data} />;
    case MdsItemListRowType.SectionHeader:
      return <MdsItemListSectionHeaderRow data={data} />;
    case MdsItemListRowType.Padding:
      return <div style={{ height: data.payload.height }} />;
    case MdsItemListRowType.AsyncNote:
      return <MdsItemListAsyncNoteRow data={data} />;
    case MdsItemListRowType.AsyncCollection:
      return <MdsItemListAsyncCollectionRow data={data} />;
    case MdsItemListRowType.Other:
      return <MdsItemListOtherRow data={data} />;
    case MdsItemListRowType.AsyncTemplate:
      return <MdsItemListAsyncTemplateRow data={data} />;
    case MdsItemListRowType.AsyncSession:
      return <MdsItemListAsyncSessionRow data={data} />;
    default:
      throw new Error("Unknown slice type");
  }
};
